<template>
    <div class="server">
        一、申明及处理方式<br/>
1.商家与会员双方在交易履行过程中产生交易争议，双方应自行协商解决，若双方无法协商或协商不能达成一致意见，一方或双方向舒适e购申请争议处理，适用本规则。<br/>
2.舒适e购将根据本规则的规定，对商家与会员双方的争议做出处理。如本规则没有明确规定的，由舒适e购依其独立判断做出处理。<br/>
3.处理争议期间，舒适e购通过微信、QQ、电子邮件、短信或电话等方式向商家与会员双方发送的与争议处理相关的提示或通知，构成争议处理依据及结论的有效组成部分。商家与会员双方应按照舒适e购的提示或通知及时提供相关凭证。任何一方无正当理由未按照规定提供凭证的，舒适e购有权按照实际收集到的凭证做出处理。<br/>
4.舒适e购并非专业争议解决机构，仅能以普通人的认知对用户提交的凭证进行判断，舒适e购不保证争议处理结果一定符合商家与会员双方的期望，除存在故意或重大过失外，舒适e购对争议处理免责。<br/>
二、定义<br/>
1）在线交易：指商家与会员双方在舒适e购舒适e购平台上通过网站支持的在线交易方式（包括但不限于支付宝、微信交易、货到付款交易、分阶段付款交易等）所进行的交易。<br/>
2）投诉方：指在舒适e购平台上发起交易争议处理诉求的用户。<br/>
3）被投诉方：指投诉方投诉的舒适e购用户。<br/>
4）交易争议处理：指商家与会员双方在交易履行过程中产生交易争议，因双方无法自行协商或协商不能达成一致，一方或双方申请提交舒适e购进行交易调处处理。<br/>
三、受理条件<br/>
1）投诉方须提供真实、有效的身份证明、联系方式；<br/>
2）有具体明确的被投诉方；<br/>
3）有具体明确的投诉请求、事实和理由；<br/>
4）提供必要、准确、详实的事实依据和证明材料；<br/>
5）为在线交易；<br/>
6）其他舒适e购认为需要具备的条件。<br/>
四、受理范围<br/>
受理的争议范围：商品问题、商家行为类问题、会员行为类问题、其他特殊问题等，具体如下：<br/>
1、商品问题：会员所购买商品本身存在描述不符、瑕疵、破损、使用故障等问题；<br/>
2、商家行为类问题：商家违反交易规则或约定的行为问题；<br/>
3、会员行为类问题：会员违反交易规则或约定的行为问题；<br/>
4、其他特殊问题：其他舒适e购认为需要受理的特殊问题；<br/>
5、如舒适e购舒适e购平台相关行业有特殊规定，以行业的独立标准为准。<br/>
超出本规则受理期间或范围、不满足本规则受理条件的交易争议，舒适e购不予受理。<br/>
五、商家与会员交易须知<br/>
1.发货、收货、退货相关问题<br/>
（1）发货<br/>
1）会员下单时，有义务向商家提供有效的收货地址，保证本人或相关授权代收人可签收，如临时变更地址，需及时与商家沟通并达成一致，否则因此导致的损失由会员承担。<br/>
2）商家发布商品信息时应当对商品承运、配送方式（自提、物流配送等）及发货运费担负等相关要素作出清晰、显著的表述或与会员约定一致。否则，由此引发的争议由商家承担相关不利后果。<br/>
3）会员对发货时限、到货时限、包装方式等有特殊要求，应在下单前与商家确认，或在下单后取得商家同意，否则之后拒收或主张退货，相应风险由会员自行承担。<br/>
4）已约定发货或到货时间，因商家原因超期，会员拒收后，商家应自行联系物流及时召回商品，否则因此导致的损失由商家自行承担。<br/>
5）商家超过约定的发货时间或会员申请退款时尚未发货的，商家应当在征得会员同意后再发货，否则会员拒签导致的损失由商家承担。本规则或平台其他规则另有规定的，从其规定。<br/>
6）商家交付会员的商品存在大量且严重劣质、大量货不对板情形的，经舒适e购综合判断，有理由认为商家无履行合同之意图的，则视为商家拒绝履约，交易支持退款会员，商品由商家自行和会员协商处置。<br/>
本条款说明：<br/>
舒适e购将根据会员投诉、举报及结合大数据技术对商家的交易行为、交易模式、账号历史记录等多个纬度进行排查、取证、核实，经综合判断认定商家不以交易为目的，并无合同履行之意图，交易将支持退款。<br/>
（2）收货<br/>
1）会员签收商品前，应就能够即时验收的表面一致问题，包括但不限于是否存在破损、变形、少/错件等情况进行判断，并有权在出现上述情形时拒签商品；一旦签收，则不得以商品存在即时验收范围内的瑕疵或缺陷为由主张退款、退（换）货，但会员能够提供有效相反证据或交易双方另有约定的除外。商家收款后遵循同样规则。<br/>
2）会员无正当理由拒签商品，产生的损失由会员承担。商家收退货时遵循同样规则。<br/>
3）商家发货或会员退货后，收件人应当亲自签收商品，也可委托他人签收商品或指示承运人将商品置于收件人指定的地点。收件人委托他人签收商品或承运人已按收件人的指示将商品置于指定地点的，视为收件人本人签收。<br/>
本条款说明：<br/>
符合下述任一情形的， 亦将视为收件人本人签收：<br/>
a、收件人成年家属签收的；<br/>
b、经收件人同意，置于指定地点的商品；<br/>
c、跨境转运的，商品被收件人/会员委托的境内承运人签收的；<br/>
d、收件人信息缺失或不特定，商品在收件地址被签收的；<br/>
e、其他依据交易习惯及常人认知水准综合判断后予以认定的情形。<br/>
（3）退货<br/>
1)交易双方达成退货协议后，商家有义务向会员提供有效的收货地址，保证本人或相关授权代收人可签收，否则因此导致的损失由商家承担。<br/>
2)会员不得擅自使用平邮、运费到付的方式进行退货，使用物流方式退货时，应提前与商家确认是否方便提货，否则导致损失由会员承担。<br/>
3)在商品本身无问题，交易双方协议退货的情况下，会员须保证所退商品不影响商家的二次销售，否则会员需承担全部责任。<br/>
4)交易双方在退（换）货时应明确约定运费的承担方，若因约定不明导致纠纷，舒适e购将根据责任判定运费的承担方。包邮的交易，如仅因会员主观原因退货，会员需承担商家发货运费和退货运费，但交易双方另有约定的除外。<br/>
5)商家与会员双方交易涉及定金的，若违约方的违约行为适用定金罚则，舒适e购将予支持适用该罚则。<br/>
定金数额可由双方协议约定，但不得超过主合同标的额的20%，超出部分不予适用定金罚则。<br/>
本条款说明：<br/>
定金罚则：会员不履行约定的债务的，无权要求返还定金；商家不履行约定的债务的，应当双倍返还定金。<br/>
6)交易作退货退款处理的，若商品性质已不适宜退货，则作退款处理。本规则另有说明的，从其说明。<br/>
本条款说明：<br/>
商品性质不适宜退货的情形，包括但不限于：<br/>
1、已损毁的商品。<br/>
2.价格优惠及赠品问题<br/>
1)针对存在价格优惠的，任意方不得基于交易后期发生部分或全部退货的情况，主张按照优惠前的货物价格计算相关费用，但双方另有约定的除外。<br/>
2)针对商家未在销售页面进行标注或在订单成交前未告知会员其所购货物附送赠品的，会员不得就赠品主张异议，无论最终会员是否收到赠品。<br/>
3)商家须在销售页面显著位置标注赠品价值，否则不得在后续发生赠品退回且损坏的情况下，向会员主张损失赔偿。<br/>
3.其他注意事项<br/>
1)商家对销售的商品负有承担售后问题的责任，须自觉遵守对会员做出的售后服务承诺，并遵守舒适e购的规则及相关法律、法规的规定。二手、库存类商品另有约定的除外。<br/>
2)会员不得以部分商品存在描述不符或质量问题为由，主张全部商品的退款或退（换）货，如根据商品特性确需全部退货或交易双方另有约定的除外。<br/>
3)商家发出的商品被国家行政司法机关（包括但不限于海关、工商行政管理局、人民法院等）扣押、查封，在会员提供相关证明材料后，商家应承担相应责任。<br/>
六、违规处理<br/>
（一）扣分处理<br/>
1.商品或服务问题处置<br/>
1.1会员主张商家所售商品或提供服务存在如下情形的，经舒适e购介入判责认定后，分别作下述处置：<br/>
a)收货破损；<br/>
b)收货少件、购A发B；<br/>
c)描述不符（如外观、材质、尺寸、功能、品牌等）；<br/>
d)质量问题（如“三无”、性能故障等）；<br/>
出现a情形的违规，每次扣6分；<br/>
出现b情形的违规，前二次每次扣6分，第三次及以上每次扣12分；<br/>
出现c、d情形的违规，首次扣12分，第二次及以上每次扣24分；<br/>
2.商家行为类问题的扣分处理<br/>
2.1 商家无正当理由怠于或拒绝履行发货义务的，依情形分别作如下处置，本规则另有说明的，从其说明：<br/>
    a)成交不卖，前二次每次扣6分，第三次及以上每次扣12分。<br/>
    b)迟延发货，每次扣12分。<br/>
注：舒适e购介入后，商家无正当理由未在舒适e购要求的时间内发货的，视为拒绝发货，依照本条第一款“成交不卖”予以处置。<br/>
2.2商家违背其他交易相关承诺或约定的，每次扣12分，包括但不限于以下情形：<br/>
    a)承诺或约定给予赠品，实际未履行的；<br/>
    b)承诺或约定开具发票，实际未履行的；<br/>
    注：商家事先未予显著明示或双方未有约定的，交易实际成交金额默认为含税价；<br/>
    c)承诺或约定退货、换货、补寄、维修等服务，实际未履行的；<br/>
    d)未采用承诺或约定的物流/快递进行发货的。<br/>
3.商家发生争议纠纷或出现危及交易安全相关情形的违规，且未予在舒适e购要求的时间内解决该争议或相关情形的，基于交易安全及用户权益保障，舒适e购有权采取临时性市场管控措施对商家店铺予以监管，包括但不限于限权冻结等监管手段，至争议解决后，可向舒适e购申请解除管控。<br/>
“危及交易安全情形”包括但不限于：收款不发货、虚假发货导致钱货一方的；会员因退货、换货、维修等原因寄回商品，商家不予处理导致钱货一方的等情形。<br/>
3.会员行为类问题的扣分处理<br/>
未按约定付款：商家已按约定发货，会员签收后少付款或未按约定时间付款。<br/>
    a) 情节较轻，在舒适e购介入判责后，会员配合解决争议的，扣12分；不配合，扣24分。<br/>
    b) 情节严重，在舒适e购介入判责后，会员配合解决争议的，扣24分；不配合，扣60分。<br/>
4.其他特殊问题的处理<br/>
    a）被投诉方提供证据证明因不可抗力的原因造成违约的，不予扣分。<br/>
    b）被投诉方因同一原因被多次投诉的，舒适e购有权采取特殊的处理及扣分方式。<br/>
（二）处理说明<br/>
<table>
    <tr><th>累计扣分</th><th>处理方式</th></tr>
    <tr><td>≥12，＜24</td><td>警告（商品共享集市功能停用）</td></tr>
    <tr><td>≥24，＜36</td><td>限权7天（店铺屏蔽）</td></tr>
    <tr><td>≥36，＜48</td><td>限权15天 （店铺屏蔽）</td></tr>
    <tr><td>≥48，＜60</td><td>限权30天 （店铺屏蔽）</td></tr>
    <tr><td>≥60</td><td>关闭账户清退</td></tr>
</table>
七、附则<br/>
1.处理争议期间，舒适e购使用自有资金代替商家先行退款给会员（亦称“先行垫付”）的，交易做出处理后，舒适e购有权将商家保障金账户中与先行垫付金额相当的部分划扣至舒适e购账户。<br/>
2.舒适e购对争议做出处理后，不免除商家与会员双方基于与舒适e购签署的其他协议、规则应当承担的责任。<br/>
3.舒适e购定期或不定期的官方活动对应规则，或特殊业务场景协议/规则，对商家与会员双方争议处理有特殊要求的，按照活动规则或特殊业务场景协议/规则的特殊要求进行处理。<br/>
4.舒适e购可根据国家法律法规变化及维护市场秩序、保护用户合法权益需要，不时修订本规则，并以网站公示等方式提前通知，修订后的规则于通知指定日生效。会员和（或）商家不同意相关变更的，可自行协商或通过其他途径解决争议。<br/>
    </div>
</template>
<script>
export default {
    name: 'registerServer',
    data () {
        return {
            title: '用户注册协议'
        }
    },
    methods: {
        onBack () {
            this.$router.go(-1)
        }
    }
}
</script>
<style lang="scss" scoped>
    .server{
        padding: 24px;
        font-size: 24px;
        background: #ffffff;
    }
    label{
        font-weight: bold;
    }
    table {
        border-collapse: collapse;
    }
    table, td, th {
        border: 1px solid black;
    }
</style>